/***
 *
 *   RESET PASSWORD
 *   Phase 9 — reference reset-password chrome. Keep live email + jwt fields.
 *
 **********/

import React, { useContext } from 'react';
import { Animate, Form, Link, useNavigate, useLocation } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';

export function ResetPassword(props) {
    const { _t } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const context = useContext(AuthContext);

    const qs = location.search;
    const token = qs.includes('token=')
        ? qs.substring(qs.indexOf('token=') + 6)
        : '';

    return (
        <Animate type="pop">
            <AuthPage
                title={_t('password.reset.text')}
                description={_t('password.setNew')}
                footer={
                    <>
                        <Link url="/signin" text={_t('signin.label')} />
                    </>
                }>
                <Form
                    data={{
                        jwt: {
                            type: 'hidden',
                            value: token,
                        },
                        email: {
                            label: _t('email.label'),
                            type: 'email',
                            required: true,
                        },
                        password: {
                            label: _t('password.new'),
                            type: 'password',
                            required: true,
                            complexPassword: true,
                        },
                    }}
                    url="/api/auth/password/reset"
                    method="POST"
                    auth={false}
                    buttonText={_t('password.setNew')}
                    callback={(res) => {
                        res.data['2fa_required']
                            ? navigate(`/signin/otp?token=${res.data.token}`)
                            : context.signin(res);
                    }}
                />
            </AuthPage>
        </Animate>
    );
}
